export const secondsToHumanReadable = (seconds) => {
    const years = Math.floor(seconds / (3600 * 24 * 365));
    seconds -= years * (3600 * 24 * 365);

    const days = Math.floor(seconds / (3600 * 24));
    seconds -= days * (3600 * 24);

    const hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;

    const minutes = Math.floor(seconds / 60);
    seconds = (seconds % 60).toFixed(2); // Round to two decimal places

    const timeParts = [];
    if (years > 0) {
        timeParts.push(`${years} year${years > 1 ? 's' : ''}`);
    }
    if (days > 0) {
        timeParts.push(`${days} day${days > 1 ? 's' : ''}`);
    }
    if (hours > 0) {
        timeParts.push(`${hours} hour${hours > 1 ? 's' : ''}`);
    }
    if (minutes > 0) {
        timeParts.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
    }
    if (parseFloat(seconds) > 0) { // Check if seconds are greater than 0 after conversion to float
        timeParts.push(`${seconds} second${parseFloat(seconds) !== 1 ? 's' : ''}`);
    }

    return timeParts.join(', ');
};


export const formatLargeNumber = (value) => {
    if (value >= 1000000000000) {
        return (value / 1000000000000).toFixed(2) + 'T'; // Trillions
    } else if (value >= 1000000000) {
        return (value / 1000000000).toFixed(2) + 'B'; // Billions
    } else if (value >= 1000000) {
        return (value / 1000000).toFixed(2) + 'M'; // Millions
    } else if (value >= 1000) {
        return (value / 1000).toFixed(2) + 'K'; // Thousands
    } else if (value % 1 !== 0) {
        return value.toFixed(2); // Decimal numbers
    } else {
        return value; // Values less than 1000
    }
};

export const formatNumber = (num, fractions=0) => {
    return num.toLocaleString(undefined, { minimumFractionDigits: fractions, maximumFractionDigits: fractions });
};